













































import { defineComponent, ref, PropType, computed } from '@vue/composition-api';
import { trackEvent } from './../../../../utils/index';
import { DEFAULT_SAVED_AUDIENCE_ID, savedAudienceItem } from '@tt4b/ttam-enums';

const name = 'ttam-saved-audience-select-subcpn';
export default defineComponent({
  name,
  props: {
    options: {
      type: Array as PropType<savedAudienceItem[]>,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    optionPopoverContent: {
      type: Object as PropType<{ title: string; content: string }>,
      default: () => ({
        title: '',
        content: '',
      }),
    },
  },
  setup(props, { emit }) {
    const selectRef = ref(null);
    const selectedValue = computed({
      get: () => (props.value === DEFAULT_SAVED_AUDIENCE_ID ? '' : props.value),
      set: value => {
        emit('change', value);
      },
    });

    const hoverIndex = ref(0);

    function viewItemDetail(item) {
      emit('view-detail', item);
    }

    function handleMouseenter(item) {
      hoverIndex.value = item.value;
    }
    function handleMouseLeave() {
      hoverIndex.value = 0;
    }

    function onClickSelectButton() {
      trackEvent('import_saved_audience_use');
    }

    return {
      name,
      selectedValue,
      selectRef,
      hoverIndex,
      viewItemDetail,
      handleMouseenter,
      handleMouseLeave,
      onClickSelectButton,
    };
  },
});
